const dialogText = {
  productDetailOffer: {
    make: {
      offer: "Teklif Ver",
      approve: "Onayla",
    },
    withdraw: {
      offer: "Teklifi Geri Çek",
      approve: "Onayla",
    },
  },
  offerBox: {
    amount: " Kadar Teklif Ver",
  },
  offerInput: {
    placeholder: "Teklif Belirle",
  },
  productDetailPurchase: {
    buy: "Satın Al",
    question: "Satın almak istiyor musunuz?",
    back: "Vazgeç",
  },
  accountOffer: {
    accept: {
      offer: "Kabul et",
      question: "Teklifi kabul etmek istiyor musunuz?",
      back: "Vazgeç",
    },
    reject: {
      offer: "Reddet",
      question: "Teklifi reddetmek istiyor musunuz?",
      back: "Vazgeç",
    },
  },
  accountPurchase: {
    offer: "Satın Al",
    question: "Satın almak istiyor musunuz?",
    back: "Vazgeç",
  },
};

export default dialogText;
